import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TwoFAOutlineIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "TwoFAOutline",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M21.26 12.15c-.21-.22-.51-.35-.83-.35s-.62.13-.83.35l-5.25 5.25-1.99-1.99c-.21-.22-.51-.35-.83-.35s-.62.13-.83.35c-.21.21-.34.5-.34.82 0 .33.13.62.34.83l2.83 2.83c.21.21.49.34.81.34h.08c.32 0 .61-.13.82-.34l6.05-6.05c.21-.21.35-.51.35-.83s-.14-.63-.36-.85Zm-5.27-7.09 8.75 4.75c-.13 5.13-1.15 9.04-3.1 11.91a19 19 0 0 1-5.57 5.07l-.09.05a18.8 18.8 0 0 1-5.61-5.06l-.04-.05c-1.95-2.87-2.97-6.77-3.1-11.91l8.75-4.75Zm0-3.06c-.16 0-.31.05-.44.12L4.9 7.9c-.28.16-.47.46-.48.8 0 6.94 1.44 11.43 3.6 14.6 2.15 3.17 4.96 4.94 7.48 6.55.14.09.31.15.49.15.19 0 .36-.06.5-.15 2.52-1.61 5.32-3.36 7.5-6.55s3.6-7.66 3.6-14.6v-.03c0-.34-.19-.63-.47-.77S16.44 2.12 16.44 2.12a.9.9 0 0 0-.44-.11Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.43 29.29c-.14 0-.29-.03-.42-.08-.12-.05-12.15-5.03-12.15-19.35 0-.4.21-.77.55-.98l11.43-6.86c.36-.22.81-.22 1.18 0l11.43 6.86c.34.21.55.58.55.98 0 14.32-12.03 19.3-12.15 19.35-.14.05-.28.08-.42.08M6.15 10.5c.3 10.96 8.3 15.45 10.28 16.39 1.98-.94 9.98-5.43 10.28-16.39L16.43 4.33z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.29 20.14c-.3 0-.59-.12-.81-.33l-3.43-3.43a1.14 1.14 0 0 1 0-1.62 1.15 1.15 0 0 1 1.62 0l2.62 2.62 4.91-4.91a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-5.71 5.71c-.21.21-.51.33-.81.33Z"
      })]
    })
  }));
};
TwoFAOutlineIcon.displayName = 'TwoFAOutlineIcon';